<template>
  <!-- ==================== CONTENIDOS ==================== -->
  <div class="login-contenido">

  <div class="mainFrame" id="loginMainFrame">

      <img id="logoVeltium" src="assets/img/logo-veltium.svg" />

      <!-- Rquest account deletion message -->

      <div v-if="confirm_account_deletion_show_alert" :class="warning">
          <div id="title" class="warning-title">
              {{ $t('confirm_account_deletion.alert_title') }}</div>
          <div id="message" class="warning-text">
            {{ $t('confirm_account_deletion.alert_msg') }}</div>
      </div>

      <div class="msg-normal-grande"><br>{{title}}<br></div>
      <!-- salto de línes -->
      <br>

      <br>

      <!-- repear the bellow for a list of devices -->

      <div class="msg-normal">{{$t('confirm_account_deletion.selectNewAdmin')}}

      </div>
      <br>
      <br>

      <template v-for="device in userDevices.newAdminsArray" :key="device.device.id">

      <!-- select component to let the user select which user will be
       the next administrator of the device. Show is this.usersToPromote ==true -->
      <div id="device.device.id" v-if="device" class="">
        <div class="msg-normal">
            {{ device.device.name_for_user }}:
            &nbsp;&nbsp;
        <select v-model="selectedUser" @change="selectUser($event, device.device.id)">
          <option v-for="user in device.newAdmins"
            :value="user.email" :key="user.id" >{{ user.email }}</option>
        </select>

      </div>
      <br>
      </div>

    </template>
    <br>
    <div class="msg-normal">{{ message2 }}</div>
    <br>
      <!-- submit -->
      <input type="submit" class="login-button-delete" maxlength="32"
          :disabled="confirm_account_deletion_in_submission"
          test-data="sendButton"
          :value="$t('confirm_account_deletion.send')"/>
      <!-- Back to Login -->
      <div class="forgot" v-show="!mail_sent">
      <router-link to="/login">{{$t('confirm_account_deletion.back')}}</router-link>
      </div>

  </div>

  </div>
  <!-- ==================== /CONTENIDOS ==================== -->
  </template>
<script>

import '../assets/veltium-login.css';
import { checkAdmin } from '../includes/api-service';

export default {
  name: 'confirm_account_deletion',
  data() {
    return {
      confirm_account_deletionSchema: {
        email: 'required|email',
      },
      email: '',
      locale: '',
      token: '',
      title: this.$t('confirm_account_deletion.message'),
      message2: `${this.$t('confirm_account_deletion.message2')} ${this.$route.query.email}`,
      confirm_account_deletion_in_submission: false,
      confirm_account_deletion_show_alert: false,
      confirm_account_deletion_alert_variant: 'bg-white-500',
      confirm_account_deletion_alert_msg: this.$t('confirm_account_deletion.wait'),
      mail_sent: false,
      userDevices: [],
      selectedDevicesUsers: [],
    };
  },
  computed: {

  },
  methods: {
    async confirm_account_deletion(values) {
      console.log('confirm_account_deletion', values);
    },
    reset() {
      this.email = '';
      this.$router.push('login');
    },
    usersToPromote(deviceId) {
      console.log('usersToPromote', deviceId);

      return true;
    },
    selectUser(event, deviceid) {
      console.log('selectUser', deviceid, event.target.value);
      // first delete from selectedDevicesUsers the device if it is already there
      this.selectedDevicesUsers = this.selectedDevicesUsers
        . filter((user) => user.deviceId !== deviceid);
      // add the user to the list of users to promote together with the device ID
      this.selectedDevicesUsers.push({ deviceId: deviceid, email: event.target.value });
    },
    unSelectUser(event) {
      console.log('unSelectUser', event.target.value);
      // remove the user from the list of users to promote
      this.selectedDevicesUsers = this.selectedDevicesUsers
        . filter((user) => user.email !== event.target.value);
    },
  },
  // get the email from the route (GET parameter) nad locale and token
  created() {
    console.log('created', this.$route.query.email, this.$route.query.locale, this.$route.query.token);
    this.email = this.$route.query.email || 'anonymous';
    this.locale = this.$route.query.locale || 'en';
    this.token = this.$route.query.token || '-';

    if (this.email === 'anonymous') {
      this.confirm_account_deletion_show_alert = true;
      this.confirm_account_deletion_alert_variant = 'bg-red-500';
      this.confirm_account_deletion_alert_msg = this.$t('confirm_account_deletion.error');
    }

    // call to the API to check if the user is admin of any device, and need to promote another user

    checkAdmin(this.email, this.token)
      .then((response) => {
        console.log('checkAdmin', response);
        if (response.result === 'success') {
          this.userDevices = response.data;
        }
      })
      .catch((error) => {
        console.log('checkAdmin', error);
      });
  },
};
</script>
